module.exports = __webpack_public_path__ + "img/righticon.3d2a80d8.svg";